<template>
  <b-container class="pt-4 pb-4">
    <b-row class="align-items-center" no-gutters>
      <b-col class="d-flex align-items-center" cols="auto">
        <b-form-checkbox
            :disabled="readOnly || !validatedField || validatedField.readOnly"
            :data-test-path="'form-'+ validatedField.validatedForm.formConfig.formId +'-' + fieldConfig.fieldName"
            v-model="validatedField.value"
            class="d-flex align-items-center"
        >
          {{ fieldConfig.fieldLabel }}
        </b-form-checkbox>
      </b-col>
      <b-col class="pl-1 pr-0 align-self-center" cols="auto">
        <HintEditor
            v-if="fieldConfig.hintEnable"
            ref="hint"
            :validated-field="validatedField"
            :field-config="fieldConfig"
            :editor-mode="editorMode"
            :help-message="fieldConfig.htmlHelpText"
            :help-title="fieldConfig.helpWindowTitle"
        >
        </HintEditor>
      </b-col>
      <b-col class="pl-1 pr-0 align-self-center" cols="auto">
        <span v-if="fieldConfig.readOnly" class="text-primary">
          <font-awesome-icon icon="lock" style="height: 12px; padding-bottom: 1px;"></font-awesome-icon>
        </span>
        <span v-if="extraTip" class="text-primary" @click="showTooltip">
          <font-awesome-icon icon="circle-question"
                             style="height: 16px; color: orange;"></font-awesome-icon>
        </span>
      </b-col>
    </b-row>
    <b-row no-gutters>
      <small v-if="validatedField && labelTip"
             class="form-text text-warning font-weight-bold">{{ labelTip || '&nbsp;' }}
      </small>
    </b-row>
  </b-container>
</template>

<script>

import FormValidatedField from "@/components/forms/FormValidatedField";
import InputBase from "@/components/inputs/InputBase";
import CheckboxFormFieldConfig from "@/server/com/silkplm/engine/forms/schema/definition/CheckboxFormFieldConfig";
import HintEditor from "@/components/inputs/controls/HintEditor";
import {
  findFieldValueFromCompanyCompanyConfigurationFormField
} from "@/components/forms/customizations/plm/EntityEditFormService";
import DialogManager from "@/utils/DialogManager";

export default {
  name: "CheckboxRenderer",
  components: {InputBase, HintEditor},


  created() {
  },

  async mounted() {
    this.validatedField.validatedForm.openFromGrid = this.openFromGrid;
    this.assignLabelTip();
    this.assignExtraTip();
  },

  // destroyed() {
  //   if(this.openFromGrid){
  //     this.validatedField.validatedForm.openFromGrid = false;
  //   }
  // },

  methods: {
    setReadOnly(readOnly) {
      this.readOnly = this.fieldConfig.readOnly || readOnly;
    },

    setEditorMode(val) {
      this.editorMode = val;
    },

    assignLabelTip() {
      let fieldConfig = this.fieldConfig;
      let validatedField = this.validatedField;
      let formId = validatedField.validatedForm.formConfig.formId;
      this.labelTip = findFieldValueFromCompanyCompanyConfigurationFormField(validatedField.validatedForm.formConfig, fieldConfig, "labelTip");
    },

    async showTooltip() {
      await DialogManager.infoShort(this.fieldLabel + ' ' + $tr('extra.tip.title', 'additional tip'), this.extraTip);
    },

    assignExtraTip() {
      let fieldConfig = this.fieldConfig;
      let validatedField = this.validatedField;
      let formId = validatedField.validatedForm.formConfig.formId;
      this.extraTip = findFieldValueFromCompanyCompanyConfigurationFormField(validatedField.validatedForm.formConfig, fieldConfig, "extraTip");
      this.extraTip?.replaceAll("\n", '<br />');
    }
  },

  props: {
    validatedField: {type: FormValidatedField, required: true},
    fieldConfig: {type: CheckboxFormFieldConfig, required: true},
    openFromGrid: {default: false},
    gridEditor: {default: null},
    mode: {default: null},
  },

  watch: {
    "validatedField.value": function (newVal, oldVal) {
    },
  },

  data: () => ({
    readOnly: true,
    editorMode: false,
    hintInputMessage: "",
    labelTip: null,
    extraTip: null,
  })
}
</script>